import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { fetchNoteTypes, postNote, postNoteDocument, postSummary } from "../../../../services/httpClient";
import Contact from "./Contact";
import Intervention from "./Intervention";
import Referral from "./Referral";
import Standard from "./Standard";
import StudentConnections from "./StudentConnections";
import useApp from "../../../../utils/useApp";
import { User } from "../../../../types/user";
import SelectObject from "../../../ui/SelectObject";
import Infraction from "./Infraction";
import CustomNote from "./CustomNote";

interface CreateNoteState {
  fetchNotes?: any;
  setViewNotes: any;
  setCreateNote: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
  family: User[];
  saveIsEnabled: boolean;
  setSaveIsEnabled: any;
  setUserToSave: any;
  setSummary: any;
}

const CreateNote = ({
  fetchNotes,
  setViewNotes,
  setCreateNote,
  setShowToast,
  setToastText,
  setToastBody,
  family,
  saveIsEnabled,
  setSaveIsEnabled,
  setUserToSave,
  setSummary,
}: CreateNoteState) => {
  const { id } = useParams();
  const { showMenu }: any = useApp();
  const [type, setType] = useState<string>("");
  const [typeObject, setTypeObject] = useState<any>({});
  const [newNote, setNewNote] = useState<any>({});
  const [docs, setDocs] = useState<any[]>([]);
  const [types, setTypes] = useState<any[]>([]);
  const [errMsg, setErrMsg] = useState<string>("");

  useEffect(() => {
    getTypes();
  }, []);

  const getTypes = () => {
    fetchNoteTypes()
      .then((res: any) => {
        var types = res[0].data.filter((n: any) => n?.type !== "system");
        types = types.filter((t: any) => t?.is_published === 1);
        types = types.filter((n: any) => n?.is_archived !== 1);

        var sorted = [...types];
        sorted.sort((a: any, b: any) => a.is_archived - b.is_archived);

        setTypes(sorted);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const updateType = (e: any) => {
    setType(e.target.value);
    var fullType = types.find((t: any) => t.key === e.target.value);
    setTypeObject(fullType);
    setSaveIsEnabled(false);
    setUserToSave(false);
  };

  const onClickSave = () => {
    setErrMsg("");
    postNote(newNote, id)
      .then((res: any) => {
        //Special code for Standard type notes
        const noteId = res[0].data.note_id;
        if (newNote.notetype === "standard" && docs.length > 0) {
          const length = docs.length;
          var counter = 0;
          docs.map((d: any) => {
            counter++;
            const name = d.name;
            const data = d.data;

            postNoteDocument(name, data, id, noteId)
              .then((res: any) => {
                if (counter === length) {
                  fetchNotes();
                  setViewNotes(true);
                  setCreateNote(false);
                  setUserToSave(false);
                  setShowToast(true);
                  setToastText("Note Created");
                  setToastBody(title(newNote.notetype));
                }
              })
              .catch((err: any) => {
                setErrMsg(err?.response?.data?.msg || "Failed to save note document");
              });
          });
        } else {
          fetchNotes();
          setViewNotes(true);
          setCreateNote(false);
          setUserToSave(false);
          setShowToast(true);
          setToastText("Note Created");
          setToastBody(newNote?.type === "custom" ? newNote.notetypename : title(newNote.notetype));
        }

        postSummary(id)
          .then((res: any) => {
            var magic = res[0].data?.summary?.postResponse;
            setSummary(magic);
          })
          .catch((err: any) => {
            console.log(err);
          });
      })
      .catch((err: any) => {
        setErrMsg(err?.response?.data?.msg || "Failed to save note");
      });
  };

  const title = (type: any) => {
    if (type === "student") {
      return "Student Connections";
    } else if (type === "intervention") {
      return "Intervention Follow-Up";
    } else {
      return type.charAt(0).toUpperCase() + type.slice(1);
    }
  };

  return (
    <>
      <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
        {errMsg}
      </p>
      <Card className={showMenu ? "bg-light sticky-top card-note-menu-open-sticky" : "bg-light sticky-top card-note-sticky"}>
        <Row className="pe-0 mb-3 mt-3">
          <Col className="col-6">
            <SelectObject label="Note Type" value={type} options={types} onUpdate={(e: any) => updateType(e)} />
          </Col>
          <Col className="col-4"></Col>
          <Col className="col-2 d-flex justify-content-end align-items-center">
            <Button className="app-secondary-color button" onClick={() => onClickSave()} disabled={!saveIsEnabled}>
              Save
            </Button>
          </Col>
        </Row>
      </Card>
      {type === "standard" && (
        <Standard
          family={family}
          documents={docs}
          setDocuments={setDocs}
          setUpdatedNote={setNewNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={true}
        />
      )}
      {type === "contact" && (
        <Contact
          family={family}
          setUpdatedNote={setNewNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={true}
        />
      )}
      {type === "intervention" && (
        <Intervention
          family={family}
          setUpdatedNote={setNewNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={true}
        />
      )}
      {type === "referral" && (
        <Referral
          family={family}
          setUpdatedNote={setNewNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={true}
        />
      )}
      {type === "student" && (
        <StudentConnections
          family={family}
          setUpdatedNote={setNewNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={true}
        />
      )}
      {type === "infraction" && (
        <Infraction
          family={family}
          noteType={typeObject}
          setUpdatedNote={setNewNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={true}
        />
      )}
      {/^\d+_/.test(type) && (
        <CustomNote
          key={typeObject?.key}
          family={family}
          type={typeObject}
          setUpdatedNote={setNewNote}
          setSaveIsEnabled={setSaveIsEnabled}
          setUserToSave={setUserToSave}
          myCase={true}
        />
      )}
    </>
  );
};

export default CreateNote;
